import { SCROLLABLE_BY_WHEEL_REF_NAME } from './constants';
import { ClientEvent } from '../../enums';
import { StyleOverflowType } from '../../styles/enums';

const ScrollWheelHorizontal = {
  methods: {
    handleWheel(event) {
      if (!this.getHasElementScroll()) {
        return;
      }

      event.preventDefault();

      this.scrollElement(event.deltaY);
    },

    getRef() {
      const ref = this.$refs[SCROLLABLE_BY_WHEEL_REF_NAME];

      if (!ref) {
        return null;
      }

      return ref.$el || ref;
    },

    getHasElementScroll() {
      return this.getRef().scrollWidth > this.getRef().clientWidth;
    },

    scrollElement(deltaY) {
      this.getRef().scrollLeft += deltaY || 0;
    },
    addOverflowXStyle() {
      this.getRef().style.overflowX = StyleOverflowType.Auto;
    },
  },
  mounted() {
    if (!this.getRef()) {
      return;
    }

    this.addOverflowXStyle();

    this.getRef().addEventListener(ClientEvent.Wheel, this.handleWheel);
  },
  destroyed() {
    if (!this.getRef()) {
      return;
    }

    this.getRef().removeEventListener(ClientEvent.Wheel, this.handleWheel);
  },
};

export default ScrollWheelHorizontal;
